import { IEmpresas } from "../interfaces/IEmpresas";
import api from "./Api";

class EmpresaNovaService {
    async cadastrar(empresaID: number, descricao: string, conta: string): Promise<any> {
        const { data: result } = await api.post<any>('v2/MapeamentoBancario', {
            empresaID,
            descricao,
            conta
        });

        return result;
    }

    async remover(id: number): Promise<void> {
        await api.delete(`v2/MapeamentoBancario/${id}`);
    }

    async listar(id: number): Promise<any[]> {
        const { data: result } = await api.get<any[]>(`v2/MapeamentoBancario/${id}`);
        return result;
    }
}


export default new EmpresaNovaService();